import styled from "styled-components";
import PropTypes from "prop-types";

const Card = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 12px;
  padding-bottom: 14px;
`;

const VoterName = styled.div`
  font-weight: 600;
  color: rgba(0, 0, 0, 0.9);
  margin-bottom: 8px;
`;

const VoterDetail = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.55);
`;

const voterDisplayName = (snapshot) =>
  [snapshot.first, snapshot.last, snapshot.suffix].filter(Boolean).join(" ");

const VoterInfo = ({ snapshot }) => {
  const stateCode = snapshot.state?.toUpperCase() || "FL";

  return (
    <Card>
      <VoterName>{voterDisplayName(snapshot)}</VoterName>
      {snapshot.city && (
        <VoterDetail>
          {snapshot.city}, {stateCode}
        </VoterDetail>
      )}
      {snapshot.stateSenateDistrict && (
        <VoterDetail>
          {stateCode} State Senate District {snapshot.stateSenateDistrict}
        </VoterDetail>
      )}
      {snapshot.stateHouseDistrict && (
        <VoterDetail>
          {stateCode} State House District {snapshot.stateHouseDistrict}
        </VoterDetail>
      )}
    </Card>
  );
};

VoterInfo.propTypes = {
  snapshot: PropTypes.object,
};

export default VoterInfo;
